import React, { useState } from "react";
import { MessageCircle, X, Phone, Mail } from "lucide-react";
import { CONTACT_CONFIG, getWhatsappLink, getMailtoLink } from "../../config/contact";

function ContactChat() {
  const [open, setOpen] = useState(false);

  return (
    <div className="contact-widget">
      {open && (
        <div className="chat-box" role="dialog" aria-label="Contact support">
          <div className="chat-header">Connect with us</div>
          <div className="chat-body">
            <p>
              <Phone size={14} strokeWidth={1.75} aria-hidden="true" /> {CONTACT_CONFIG.phoneDisplay}
            </p>
            <p>
              <Mail size={14} strokeWidth={1.75} aria-hidden="true" /> {CONTACT_CONFIG.email}
            </p>

            <a
              href={getWhatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-block whatsapp-link"
            >
              Chat on WhatsApp
            </a>
            <a href={getMailtoLink()} className="btn btn-secondary btn-block email-link">
              Send an email
            </a>
          </div>
        </div>
      )}

      <button
        type="button"
        className={`chat-button${open ? " chat-button-open" : ""}`}
        aria-expanded={open}
        aria-label={open ? "Close contact menu" : "Open contact menu"}
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? (
          <X key="close" className="chat-button-icon" size={22} strokeWidth={1.75} aria-hidden="true" />
        ) : (
          <MessageCircle key="open" className="chat-button-icon" size={22} strokeWidth={1.75} aria-hidden="true" />
        )}
      </button>
    </div>
  );
}

export default ContactChat;
